import { calculateTotalHours } from "@/lib/utils";
import { addDays, format, isBefore, isFuture, isWeekend } from "date-fns";
import { Badge } from "ui/components/badge";
import { Link } from "react-router-dom";
import React from "react";
import { cn } from "utils";

const DRAFT_TIMESHEET_DAY_VIEW = "timesheet/draft";

const TimesheetDayCell = ({ day }) => {
  const { events = [], isCurrentMonth, isToday } = day;
  const totalHours = events.reduce((sum, event) => sum + (event.hours || 0), 0);
  const date = day.date;
  const dayNumber = format(date, "d");
  const isFutureDate = isFuture(date);

  const totalLoggedHours = calculateTotalHours(events, "hours");
  const cellClasses = `relative h-24 bg-white p-3 hover:opacity-80 ${!isCurrentMonth  ? "!bg-gray-50 " : ""
    } ${ isCurrentMonth ? "!bg-white" : ""}`;

  const renderDay = () => {
    return (
      <time
        dateTime={date}
        className={cn(
          "font-medium ",
          isToday
            ? "flex h-6 w-6 items-center justify-center rounded-full bg-black text-white"
            : undefined,
          isFutureDate ? "text-muted-foreground" : "!text-base-foreground"
        )}
      >
        {dayNumber}
      </time>
    );
  };

  if (totalLoggedHours === 0) {
    const isWeekendDay = isWeekend(date);
    const sevenDaysAgo = addDays(new Date(), -8);
    const isWithinSevenDays = !isBefore(date, sevenDaysAgo);

    return (
      <Link
        className={cellClasses}
        to={!isFutureDate && `/${DRAFT_TIMESHEET_DAY_VIEW}?date=${day.date}`}
      >
        <div className="flex flex-col h-full justify-between">
          {renderDay()}
          {!isWeekendDay && !isFutureDate && (
            <Badge
              className={cn(
                "text-xs rounded-full text-muted-foreground",
                !isWithinSevenDays && "bg-zinc-50 border-zinc-400 text-zinc-400"
              )}
              variant="outline"
            >
              No Logs
            </Badge>
          )}
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={!isFutureDate && `/${DRAFT_TIMESHEET_DAY_VIEW}?date=${day.date}`}
      className={cellClasses}
    >
      <div className="flex flex-col h-full justify-between">
        {renderDay()}

        <div className="mt-auto flex justify-between text-muted-foreground text-xs font-medium">
          <div>
            {totalLoggedHours === 0 ? "No Jobs" : `${totalLoggedHours}h`}
          </div>
          <div>{totalHours}h</div>
        </div>
      </div>
    </Link>
  );
};

export default TimesheetDayCell;
